/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { SkypeTokenProvider } from './Interfaces';

export function addCacheAsBackupTo(provider: SkypeTokenProvider): SkypeTokenProvider {
    let cachedToken: string | undefined;

    return async (forceRefresh: boolean): Promise<string> => {
        if (forceRefresh) {
            cachedToken = undefined;
        }

        return new Promise<string>((resolve, reject) => {
            provider(forceRefresh).then((token: string) => {
                cachedToken = token;
                resolve(token);
            }).catch((error) => {
                if (cachedToken !== undefined && cachedToken.length > 0) {
                    resolve(cachedToken);
                }
                reject(error);
            });
        });
    };
}



// WEBPACK FOOTER //
// ./lib_temp/SkypeTokenProviderWithCache.ts